/**
 * @param {{getFBCompleteAccountConfig:any,UID:string,UIDSignature:string,signatureTimestamp:string,uniqueID:string,currentScreen:string,country_code:string,ui:any,ccpa:any,CCPAFormController:any,screenSets:any,field:string,getCreateAccountConfig:any}} data
 */
import {sendRegisterInformation} from "../cms/api";
import {sendUniqueId} from "../cms/api";
import $ from "jquery";
const dev = false;
const screenSets = {
  login: dev
    ? "NewRaas4nov15-RegistrationLogin"
    :"WOF-Registration-LiteRegistration",

  profile: dev ? "NewRaas4nov15-ProfileUpdate" : "WOF-ProfileUpdate",
  register: dev ? "NewRaas4nov15-RegistrationLogin" : "WOF-Registration-React",
};

const getAccountInfo = (gigya, resolve, reject) => {

  // Verify if Cookie Session is already present it.
  const cookieSessionGigya = document.cookie
  .split('; ')
  .find((row) => row.startsWith('SESSion_gigya_user='))
  ?.split('=')[1];

  gigya.accounts.getAccountInfo({
      callback: (response) => {
        const {
          profile = {},
          data = {},
          status,
          UID,
          statusMessage,
        } = response;
        if (status === 'OK') {

          if (typeof cookieSessionGigya === 'undefined' ) {
            // Set the Gigya Cookie Session if not present already.
            let profile_info = [
              { firstName: profile.firstName, spinID: data.spinID, uuid: UID },
            ];

            /** Check if UID is there but Unique ID is not created yet **/
            if (UID !== undefined && UID !== ""
              && (data.uniqueID == undefined || data.uniqueID == "")) {
              const uniqueIdData = sendUniqueId(UID);
            }

            let profile_info_json = JSON.stringify(profile_info);
            // Set 5 * 24 hours to expire.
            let gigya_expires = new Date(Date.now() + (5*24*60*60*1000));

            document.cookie =
              'SESSion_gigya_user=' +
              profile_info_json +
              '; expires=' + gigya_expires.toUTCString() + '; path=/; Secure';
          }

          resolve({
            uid: UID,
            profile: { ...profile, ...data },
            isLoggedIn: true,
          });
        } else {
          reject(statusMessage);
        }
      },
  });

};

const logOut = (gigya) => {
  return new Promise((resolve, reject) => {
    gigya.accounts.logout({
      callback: (response) => {
        if (response.status === "OK") {
          let oldDate = "Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie =
            'SESSion_gigya_user=; expires=' + oldDate + '; path=/';
          document.cookie.split(";").reduce((cookies, cookie) => {
            const [name] = cookie.split("=").map((c) => c.trim());
            if (name.includes("gig_bootstrap") || name.includes("SSESS")) {
              document.cookie = name + "=; expires=" + oldDate +
              "; domain=." + window.location.hostname + "; path=/";
            }
          }, {});

          resolve();

          // WOFR-1072 Adding hashed random string to avoid redirect to cached page.
          window.location.href = '/react/logout?hsid=' + Math.random().toString().substring(2);
        } else {
          reject(response.statusMessage);
        }
      },
    });
  });
};



const profile = (gigya) => {
  return new Promise((resolve, reject) => {
    getAccountInfo(gigya, resolve, reject);
  });
};

const logIn = (gigya) => {
  return new Promise((resolve, reject) => {
    gigya.accounts.showScreenSet({
      screenSet: screenSets.login,
      startScreen: "gigya-login-screen",
      onAfterSubmit: async (event) => {
        if (event.response.status === "OK") {

          const data1 = await sendRegisterInformation(
            event.response.UID,
            event.response.UIDSignature,
            event.response.signatureTimestamp
          );
          resolve();
        } else {
          reject(event.response.statusMessage);
        }
      },
    });
  });
};

const logInGiveaway = (gigya) => {
  return new Promise((resolve, reject) => {
    gigya.accounts.showScreenSet({
      screenSet: "WOF-Registration-React",
      startScreen: "gigya-login-screen",
      customLang: {
        invalid_login_or_password:
          'Invalid Login or Password. If it\'s your first time logging in on the new site, you need to <a href="/forgot-password">reset your password here.</a>',
        account_temporarily_locked_out:
          "Your account is temporarily locked. Please try again in 30 minutes. Remember to refresh the window.",
      },
      onAfterSubmit: async (event) => {
        if (event.response.status === "OK") {
          if (!event.data.uniqueID) {
            // const data = await SendIPAddress(event.response.UID);
          }
          resolve();
        } else {
          reject(event.response.statusMessage);
        }
      },
      onAfterScreenLoad: (event) => {
        let this_form = "";
        if (
          event.currentScreen === "gigya-register-screen" ||
          event.currentScreen === "gigya-register-screen-react"
        ) {
          this_form = document.getElementById("gigya-register-form");

          let fieldToChange = $(this_form).find("input[name='password']");
          let secondFieldToChange = $(this_form).find(
            "input[name='passwordRetype']"
          );

          let showCheckbox = $(this_form).find(
            ".show-password-checkbox input[type='checkbox']"
          );

          $(showCheckbox).change(function () {
            if (this.checked) {
              fieldToChange.prop({ type: "text" });
              secondFieldToChange.prop({ type: "text" });
            } else {
              fieldToChange.prop({ type: "password" });
              secondFieldToChange.prop({ type: "password" });
            }
          });

          /*
          $.ajax({
            url: '/api/user-location-data/akamai-edgescape',
            cache: false,
            dataType: 'json',
            success: (akamaiEdgescapeLocData) => {
              if (akamaiEdgescapeLocData !== "" && akamaiEdgescapeLocData.success === 1 && akamaiEdgescapeLocData.location_data.country_code) {
                if (akamaiEdgescapeLocData.location_data.country_code === 'US') {
                  $(this_form).find("input[name='subscriptions.wof_news_updates.email.isSubscribed']").prop("checked", true);
                }
                $(this_form).find('input[name="profile.firstName"]').focus();
                $(this_form).find('input[name="profile.firstName"]').attr("tabIndex", -1);
              }
              else {
                $.ajax({
                  url: '/api/user-ip-address',
                  cache: false,
                  dataType: 'json',
                  success: (ip_address_data) => {
                    if (ip_address_data != "") {
                      var ipAddress = ip_address_data.ipAddress;

                      if (ipAddress != "") {
                        $.ajax({
                            url: '/api/user-location-data?_format=json',
                            contentType : 'application/json',
                            type: "POST",
                            data : JSON.stringify(ip_address_data),
                            success: function(loc_data) {
                              if (loc_data != "") {
                                var max_mind_countryCode = loc_data.location_data.country.iso_code;
                                if (max_mind_countryCode == 'US') {
                                  $(this_form).find("input[name='subscriptions.wof_news_updates.email.isSubscribed']").prop("checked", true);
                                }
                                $(this_form).find('input[name="profile.firstName"]').focus();
                                $(this_form).find('input[name="profile.firstName"]').attr("tabIndex", -1);
                              }
                            }
                        });
                      }
                    }
                  }
                });
              }
            }
          });
          */
        }
        if (window.ccpa) {
          if (event.currentScreen === "gigya-register-screen") {
            new window.ccpa.ui.CCPAFormController(
              window.ccpa.screenSets.getCreateAccountConfig()
            );
          } else if (event.currentScreen === "wof-registration-completion") {
            new window.ccpa.ui.CCPAFormController(
              window.ccpa.screenSets.getFBCompleteAccountConfig()
            );
          }
        }
      },
      onFieldChanged: (event) => {
        let this_form = "";
        if (
          event.form === "gigya-register-form" ||
          event.form === "gigya-profile-form"
        ) {
          if (event.form === "gigya-register-form") {
            this_form = document.getElementById("gigya-register-form");
          } else if (event.form === "gigya-profile-form") {
            this_form = document.getElementById("gigya-profile-form");
          }
          if (event.field === "password") {
            let password = event.value;
            let length_point = $(this_form).find(".min-char");
            let one_num_point = $(this_form).find(".one-num");
            let one_letter_point = $(this_form).find(".one-letter");
            let one_special_char_point = $(this_form).find(".one-special-char");
            let email_portion_point = $(this_form).find(".email-portion");

            if (password !== "") {
              if (password.length >= 8 && password.length <= 20) {
                $(length_point).addClass("active");
              } else {
                $(length_point).removeClass("active");
              }

              const numeric_pattern = /\d/;
              if (numeric_pattern.test(password)) {
                $(one_num_point).addClass("active");
              } else {
                $(one_num_point).removeClass("active");
              }

              const letter_pattern = /[a-z]/i;
              if (letter_pattern.test(password)) {
                $(one_letter_point).addClass("active");
              } else {
                $(one_letter_point).removeClass("active");
              }

              const special_pattern = /^[a-zA-Z0-9- ]*$/;
              if (special_pattern.test(password) === false) {
                $(one_special_char_point).addClass("active");
              } else {
                $(one_special_char_point).removeClass("active");
              }

              let email_val = $(this_form).find("input[name=email]").val();
              if (email_val !== "") {
                email_val = email_val.split("@");
                email_val = email_val[0];
                if (password.includes(email_val) === false) {
                  $(email_portion_point).addClass("active");
                } else {
                  $(email_portion_point).removeClass("active");
                }
              }
            } else {
              $(length_point).removeClass("active");
              $(one_num_point).removeClass("active");
              $(one_letter_point).removeClass("active");
              $(one_special_char_point).removeClass("active");
              $(email_portion_point).removeClass("active");
            }
          }
          if (event.field === "profile.zip") {
            let zip = event.value;
            const us_pattern = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
            if (us_pattern.test(zip)) {
              let subscribe_field = $(this_form).find(
                "input[name='data.subscribe']"
              );
              $(subscribe_field).prop("checked", true);
            }
          }
          if (event.field === "profile.birthYear") {
            let birthYearField = $(this_form).find(
              "input[name='profile.birthYear']"
            );
            let birthYearValue = event.value;
            const maxlength = 4;
            if (birthYearValue !== "" && birthYearValue.length >= maxlength) {
              $(birthYearField).val(birthYearValue.substr(0, maxlength));
            }
          }
          if (event.field === "profile.zip") {
            let newsUpdatesField = $(this_form).find(
              "input[name='subscriptions.wof_news_updates.email.isSubscribed']"
            );
            let zip = event.value;
            if (zip !== "") {
              const canada_pattern = /[a-zA-Z][0-9][a-zA-Z](-| |)[0-9][a-zA-Z][0-9]/;
              if (!canada_pattern.test(zip)) {
                $(newsUpdatesField).prop("checked", true);
              } else {
                $(newsUpdatesField).prop("checked", false);
              }
            }
          }
        }
      },
    });
  });
};

const register = (gigya) => {
  return new Promise((resolve, reject) => {
    gigya.accounts.showScreenSet({
      startScreen: screenSets.register,
      onAfterSubmit: (event) => {
        if (event.response.status === "OK") {
          resolve();
        } else {
          reject(event.response.statusMessage);
        }
      },
    });
  });
};

export default { logIn, logOut, register, profile, logInGiveaway };
